import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// Firebase configuration - DefinePlugin replaces these at build time
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate that all required environment variables are set
function validateFirebaseConfig(): void {
    const missingVars: string[] = [];
    
    // Check each variable directly (DefinePlugin replaces these at build time)
    if (!firebaseConfig.apiKey) missingVars.push('REACT_APP_FIREBASE_API_KEY');
    if (!firebaseConfig.authDomain) missingVars.push('REACT_APP_FIREBASE_AUTH_DOMAIN');
    if (!firebaseConfig.projectId) missingVars.push('REACT_APP_FIREBASE_PROJECT_ID');
    if (!firebaseConfig.storageBucket) missingVars.push('REACT_APP_FIREBASE_STORAGE_BUCKET');
    if (!firebaseConfig.messagingSenderId) missingVars.push('REACT_APP_FIREBASE_MESSAGING_SENDER_ID');
    if (!firebaseConfig.appId) missingVars.push('REACT_APP_FIREBASE_APP_ID');
    
    if (missingVars.length > 0) {
        const errorMessage = `Firebase configuration error: Missing required environment variables:\n${missingVars.map(v => `  - ${v}`).join('\n')}\n\nPlease ensure all Firebase environment variables are set in your .env.local file.`;
        console.error(errorMessage);
        throw new Error(errorMessage);
    }
}

// Validate configuration before proceeding
validateFirebaseConfig();

// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;

try {
    app = initializeApp(firebaseConfig as {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    });
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
} catch (error) {
    const initError = error instanceof Error ? error.message : 'Unknown error';
    throw new Error(`Firebase initialization failed: ${initError}`);
}

// Export initialized services
export { auth, db, storage };
export default app;
